module.exports = __webpack_public_path__ + "img/cattunnel28.a2a425ce.jpg";